import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TreatmentPlansCard = ({ treatments, onViewAll }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 text-success';
      case 'in-progress':
        return 'bg-primary/10 text-primary';
      case 'scheduled':
        return 'bg-warning/10 text-warning';
      case 'proposed':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Treatment Plans</h3>
        <Button variant="ghost" size="sm" onClick={onViewAll}>
          View All
        </Button>
      </div>
      <div className="space-y-3">
        {treatments?.map((treatment, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg transition-smooth hover:bg-muted"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
              <Icon name="Activity" size={20} color="var(--color-primary)" />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-1">
                <h4 className="text-sm md:text-base font-semibold text-foreground">{treatment?.procedure}</h4>
                <span className={`px-2 py-0.5 text-xs font-medium rounded ${getStatusColor(treatment?.status)}`}>
                  {treatment?.status}
                </span>
              </div>
              
              <p className="text-xs md:text-sm text-muted-foreground mb-2">{treatment?.tooth}</p>
              
              <div className="flex flex-wrap items-center gap-3 text-xs md:text-sm text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Calendar" size={14} />
                  <span>{treatment?.date}</span>
                </div>
                {treatment?.dentist && (
                  <div className="flex items-center gap-1">
                    <Icon name="UserCheck" size={14} />
                    <span>{treatment?.dentist}</span>
                  </div>
                )}
                {treatment?.cost && (
                  <div className="flex items-center gap-1">
                    <Icon name="DollarSign" size={14} />
                    <span>${treatment?.cost}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TreatmentPlansCard;